import App from 'App.vue';
import 'sass/global.scss';
import { createApp } from 'vue';

createApp(App).mount('#app');
